import React, { Component } from "react";
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Modal, ModalBody, ModalHeader, Button, Label, FormGroup,Alert  } from "reactstrap";
// import { Formik } from "formik";
import axiosInstance from "../../axios-project";

class RoleModal extends Component {
  constructor(props) {
    super(props);

    this.savedUserID = 0;
    this.state = {
      id:0,
      puser: false,
      user: false,
      member: false,
      auditor: false,
      admin: false,
    };
  }

  toggle = () => {
    this.props.toggle();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.savedUserID === nextProps.currentUserID || !nextProps.curr_user) {
      return;
    }
    this.setState({ puser: true });
    this.setState({ user: false });
    this.setState({ member: false });
    this.setState({ auditor: false });
    this.setState({ admin: false });
    this.savedUserID = nextProps.currentUserID;
    this.setState({ id:  this.savedUserID });
    let role = nextProps.curr_user.roles.map(role => role.name);
    
    if (role.includes("ROLE_ADMIN")) {
      this.setState({ admin: true });
    } 
    if (role.includes("ROLE_USER")) {
      this.setState({ user: true });
    } 
    if (role.includes("ROLE_MEMBER")) {
      this.setState({ member: true });
    } 
    if (role.includes("ROLE_AUDITOR")) {
      this.setState({ auditor: true });
    } 
   

  }

  handleSubmit(event, errors, values) {
    let roles = "";
    if(values.admin){
      roles += "4,";
    }
    if(values.auditor){
      roles += "3,";
    }
    if(values.member){
      roles += "2,";
    }
    if(values.puser){
      roles += "5,";
    }
    if(values.user){
      roles += "1,";
    }
    roles = roles.slice(0,-1);
    axiosInstance
      .post("/user/" + values.id + "/updaterole/" + roles)
      .then(response => {
        window.location.reload();
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {   
    return (
      <Modal
        id="roleModal"
        isOpen={this.props.modal}
        fade
        toggle={this.toggle}
        backdrop="static"
      >
      
        <div className="modal-content">
          <ModalHeader toggle={this.toggle}>Modify User Roles</ModalHeader>
          <ModalBody>
          <div>
        <AvForm onSubmit={this.handleSubmit} model={this.state}>
        <AvGroup>
          <Label ></Label>
          <AvInput name="id"  type="hidden" />

        </AvGroup>
          <AvGroup check>
            <Label check>
              <AvInput type="checkbox" name="puser" disabled /> Public User: <Alert color="info">default role, can not do anything without approval</Alert>
            </Label>
          </AvGroup>
          <AvGroup check>
            <Label check>
              <AvInput type="checkbox" name="user" /> User: <Alert color="info">can login website, enter Projects and edit the projects he/she entered.</Alert>
            </Label>
          </AvGroup>
          <AvGroup check>
            <Label check>
              <AvInput type="checkbox"  name="member" /> Member: <Alert color="info">can login website, enter Projects and edit all the projects within his/her states.</Alert>
            </Label>
          </AvGroup>
          <AvGroup check>
            <Label check>
              <AvInput type="checkbox"  name="auditor" /> Auditor: <Alert color="info">can approve the projects entered/edited by User and Member.</Alert>
            </Label>
          </AvGroup>
          <AvGroup check>
            <Label check>
              <AvInput type="checkbox"  name="admin" /> Admin: <Alert color="info">highest role, can edit projects and modify users' roles.</Alert>
            </Label>
          </AvGroup>
 
          <FormGroup>
            <Button>Submit</Button>
          </FormGroup>
        </AvForm>
    
      </div>
           
          </ModalBody>
        </div>
      </Modal>
    );
  }
}

export default RoleModal;
